"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.borrowerChargesSchema = void 0;
var constants_1 = require("../../constants");
exports.borrowerChargesSchema = {
    type: 'object',
    required: ['amount', 'code', 'datePaid'],
    properties: {
        amount: {
            type: 'number',
            maximum: 9999999999999,
            minimum: -9999999999999,
            decimal: [15, 2],
            errorMessage: 'should be a decimal with up to 15 digits in total and 2 digits of precision',
        },
        code: {
            type: 'string',
            enum: Object.values(constants_1.BorrowerChargesCode),
            errorMessage: 'should be a valid BorrowerChargesCode Enum value',
        },
        comment: {
            type: 'string',
            minLength: 0,
            maxLength: 40,
            errorMessage: 'should have maximum length of 40 characters',
        },
        datePaid: {
            type: 'string',
            format: 'date',
            errorMessage: 'should be formatted as yyyy-mm-dd',
        },
    },
    allOf: [
        {
            if: {
                properties: {
                    code: {
                        const: constants_1.BorrowerChargesCode.Other,
                    },
                },
            },
            then: {
                required: ['comment'],
                errorMessage: 'should have the required property - comment',
                properties: {
                    comment: {
                        type: 'string',
                        minLength: 1,
                        maxLength: 40,
                    },
                },
            },
        },
    ],
};
exports.default = exports.borrowerChargesSchema;
